/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCustomerVisits200ResponseItemsInnerReview
 */
export interface GetCustomerVisits200ResponseItemsInnerReview {
    /**
     * 
     * @type {number}
     * @memberof GetCustomerVisits200ResponseItemsInnerReview
     */
    rating: number;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerVisits200ResponseItemsInnerReview
     */
    comment?: string;
}

/**
 * Check if a given object implements the GetCustomerVisits200ResponseItemsInnerReview interface.
 */
export function instanceOfGetCustomerVisits200ResponseItemsInnerReview(value: object): value is GetCustomerVisits200ResponseItemsInnerReview {
    if (!('rating' in value) || value['rating'] === undefined) return false;
    return true;
}

export function GetCustomerVisits200ResponseItemsInnerReviewFromJSON(json: any): GetCustomerVisits200ResponseItemsInnerReview {
    return GetCustomerVisits200ResponseItemsInnerReviewFromJSONTyped(json, false);
}

export function GetCustomerVisits200ResponseItemsInnerReviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomerVisits200ResponseItemsInnerReview {
    if (json == null) {
        return json;
    }
    return {
        
        'rating': json['rating'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function GetCustomerVisits200ResponseItemsInnerReviewToJSON(json: any): GetCustomerVisits200ResponseItemsInnerReview {
    return GetCustomerVisits200ResponseItemsInnerReviewToJSONTyped(json, false);
}

export function GetCustomerVisits200ResponseItemsInnerReviewToJSONTyped(value?: GetCustomerVisits200ResponseItemsInnerReview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rating': value['rating'],
        'comment': value['comment'],
    };
}

